import { useSyncExternalStore } from 'react';

import { ApiPasswordState, getApiPasswordState, subscribeToApiPassword } from '@/lib/api-password';

export const useApiPassword = (): ApiPasswordState =>
  useSyncExternalStore(subscribeToApiPassword, getApiPasswordState, getApiPasswordState);
